// extracted by mini-css-extract-plugin
module.exports = {"CardSection":"CardSection_CardSection__1GXjG"};